module.exports = {
  LEDGER_IDENTIFICATION_TYPE: {
    CARD_TX: 'CARD_TX',
    CARD_SETTLEMENT_TX: 'CARD_SETTLEMENT_TX',
    HANDLE_TX: 'HANDLE_TX',
    PAYMENT_LINK_TX: 'PAYMENT_LINK_TX',
    PAYMENT_TX: 'PAYMENT_TX',
    PARTNER_WEBHOOK_NOTIFICATION_TX: 'PARTNER_WEBHOOK_NOTIFICATION_TX',
    SETTLEMENT_TX: 'SETTLEMENT_TX',
    PARTNER_POOL_AC_FUND_TX: 'PARTNER_POOL_AC_FUND_TX',
    ENTITY_ACCOUNT_FUND_TX: 'ENTITY_ACCOUNT_FUND_TX',
    EXTERNAL_CREDIT_TX: 'EXTERNAL_CREDIT_TX',
    EXTERNAL_DEBIT_TX: 'EXTERNAL_DEBIT_TX',
    RETURNED_SETTLEMENT_TX: 'RETURNED_SETTLEMENT_TX'
  },
  LEDGER_OPERATION: {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
    HOLD: 'HOLD',
    RELEASE: 'RELEASE'
  },
  RECONCILIATION_STATUS: {
    PENDING: 'PENDING',
    ACCEPT: 'ACCEPT',
    REJECT: 'REJECT'
  }
};
